// extracted by mini-css-extract-plugin
export default {"title":"About_title__+KbSL","text":"About_text__43zk0"};